import { render, staticRenderFns } from "./ImportOwnNumberAdd.vue?vue&type=template&id=0fa372c7&scoped=true&"
import script from "./ImportOwnNumberAdd.vue?vue&type=script&lang=js&"
export * from "./ImportOwnNumberAdd.vue?vue&type=script&lang=js&"
import style0 from "./ImportOwnNumberAdd.vue?vue&type=style&index=0&id=0fa372c7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa372c7",
  null
  
)

export default component.exports